module.exports = "/_next/static/images/coctail-4993b105ff182ad3cfe4fccc688bd2f4.jpg";